import templateUrl from './component.tpl.html';
import AlEmailTemplateEditorController from './controller';

angular.module('festzelt-os.modules.templates')
    .component('alEmailTemplateEditor', {
        controller: AlEmailTemplateEditorController,
        controllerAs: 'vm',
        templateUrl: templateUrl,
        bindings: {
            templateId: '<',
            guestlistId: '<',
            availableGlTemplateStates: '<',
            cancelTrigger: '=',
            onSave: '&',
            onError: '&',
            onCancel: '&'
        }
    });



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-email-template-editor/component.js